import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { ExternalLink, Loader2 } from "lucide-react";

const CAUSALI = { carico_ddt: "Carico da DDT", carico_fattura_immediata: "Carico da fattura", manuale: "Manuale", scanner: "Scanner" };

export const MovimentiMagazzino = () => {
  const navigate = useNavigate();
  const [list, setList] = useState(null);
  useEffect(() => {
    api.get("/magazzino/movimenti").then(({ data }) => setList(data || [])).catch(() => setList([]));
  }, []);

  const openDoc = (m) => navigate(m.doc_tipo === "ddt" ? `/fornitori?ddt=${m.doc_id}` : `/fatture?open=${m.doc_id}`);

  return (
    <Card className="card-elevated" data-testid="movimenti-magazzino">
      <CardContent className="p-0 overflow-x-auto">
        {list === null ? <Loader2 className="h-5 w-5 animate-spin mx-auto my-8" /> : (
          <table className="w-full text-sm">
            <thead className="bg-secondary">
              <tr className="text-left">
                {["Data", "Articolo", "Quantità", "Causale", "Documento"].map((h) => (
                  <th key={h} className="px-4 py-3 text-[10px] uppercase tracking-widest text-muted-foreground">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {list.map((m) => (
                <tr key={m.id} className="border-t border-border" data-testid={`movimento-row-${m.id}`}>
                  <td className="px-4 py-2 text-xs whitespace-nowrap">{(m.created_at || "").slice(0, 16).replace("T", " ")}</td>
                  <td className="px-4 py-2">{m.materiale_nome}</td>
                  <td className={`px-4 py-2 tabular-nums font-semibold ${m.delta >= 0 ? "text-emerald-700" : "text-red-600"}`}>
                    {m.delta > 0 ? "+" : ""}{m.delta} {m.unita_misura}
                  </td>
                  <td className="px-4 py-2 text-xs">{CAUSALI[m.causale] || m.causale}</td>
                  <td className="px-4 py-2 text-xs">
                    {m.doc_id ? (
                      <button type="button" onClick={() => openDoc(m)} className="text-primary hover:underline inline-flex items-center gap-1" data-testid={`movimento-doc-${m.id}`}>
                        {m.doc_tipo === "ddt" ? "DDT" : "Fattura"} n. {m.doc_numero || "s.n."} <ExternalLink className="h-3 w-3" />
                      </button>
                    ) : <span className="text-muted-foreground">{m.note || "—"}</span>}
                  </td>
                </tr>
              ))}
              {list.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-muted-foreground">Nessun movimento registrato.</td></tr>}
            </tbody>
          </table>
        )}
      </CardContent>
    </Card>
  );
};
